import {tap} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';

export const visibilityTimes = ajax.cache("/questionnaire-visibility-time", 5 * ajax.MINUTES);

export function removeTime(id) {
    return ajax.deleteJson("/questionnaire-visibility-time/"+id, null, {resultType: 'text'})
    .pipe(tap(visibilityTimes.clearCache));
}

export function addTime(time) {
    return ajax.postJson("/questionnaire-visibility-time", time, {resultType: 'text'})
    .pipe(tap(visibilityTimes.clearCache));
}

export function modifyTime(id, time) {
    return ajax.putJson("/questionnaire-visibility-time/"+id, time, {resultType: 'text'})
    .pipe(tap(visibilityTimes.clearCache));
}


// WEBPACK FOOTER //
// ./modules/issFrontend/service/FiilissVisibilityService.js